import Card from '../../../../shared/types/props/card';
import Colors from '../../../../shared/assets/style/default/color';
import FastEvent from '../../../../shared/classes/fastEvent';
import HorizontalCard from './horizontalCard';
import ProgressBar from '../progressBar/eventProgressBar';
import { keepWatchingSelector } from '../../../../shared/store/slices/keepWatching.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useEffect, useState } from 'react';

function ProgressHorizontalCard({ item, index, onClick, releaseAction }: Card) {
  const { data } = useAppSelector(keepWatchingSelector);
  const [mark, setMark] = useState((item as FastEvent).keepWatchingMark || 0);
  const duration =
    (item as FastEvent)?.endBookmark ||
    ((item as FastEvent).duration
      ? (item as FastEvent).duration * 60
      : item.date
      ? (item.date.end - item.date.start) / 1000
      : 0) ||
    0;
  const percentage = mark ? (mark / duration) * 100 : 0;

  useEffect(() => {
    const keepWatchingItem = data.find((keepWatching) => {
      return keepWatching.id === item.eventId;
    });
    if (keepWatchingItem) {
      setMark(keepWatchingItem.mark);
    }
  }, [data]);
  return (
    <HorizontalCard
      item={item}
      index={index}
      progressBar={percentage > 0}
      releaseAction={onClick || releaseAction}
    >
      {percentage ? (
        <ProgressBar
          color={Colors.progress.fillFastEvent}
          percentage={percentage}
        />
      ) : (
        <></>
      )}
    </HorizontalCard>
  );
}

export default ProgressHorizontalCard;
